import { useEffect, useRef } from 'react';
import { IRemoteVideoTrack, ILocalVideoTrack } from 'agora-rtc-sdk-ng';

interface AgoraVideoPlayerProps {
  videoTrack: IRemoteVideoTrack | ILocalVideoTrack | null;
  className?: string;
}

export function AgoraVideoPlayer({ videoTrack, className = '' }: AgoraVideoPlayerProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current && videoTrack) {
      videoTrack.play(containerRef.current);
    }
    return () => {
      videoTrack?.stop();
    };
  }, [videoTrack]);

  return (
    <div 
      ref={containerRef} 
      className={`w-full h-full ${className}`}
      style={{ backgroundColor: '#000' }}
    />
  );
}
